import FractionChip from "$routes/inventory/_lib/fraction-chip";
import { useWatch } from "react-hook-form";
import type { FormValues } from "./use-fulfill-move-request-form";

interface Props {
  requestSkuId: string;
  quantityRequested: number;
}

const SkuQuantityToSendTotalChip: FC<Props> = ({
  requestSkuId,
  quantityRequested,
}) => {
  // This has been pulled out to it's own component rather than inlining in the table it was originally created for
  // because the behavior between "watch" and "useWatch" is different. Specifically, "watch" wasn't updating correctly
  // in all cases, so we've used "useWatch". The fact that's a hook meant we had to extract this to it's own component.
  const lotValuesForSku = useWatch({
    name: `skus.${requestSkuId}`,
  }) as FormValues["skus"][string];

  const totalBeingSentForSku = Object.values(lotValuesForSku || {}).reduce(
    (acc: number, curr) => acc + parseInt(curr.quantity || "0", 10),
    0,
  );

  return (
    <FractionChip
      numerator={totalBeingSentForSku}
      denominator={quantityRequested}
    />
  );
};

export default SkuQuantityToSendTotalChip;
